import { CommonImage } from '@/components/common';
import { setSearchPopup } from '@/redux/actions/common.action';
import { AppDispatch } from '@/redux/store';
import { formatEventDate } from '@/utils';
import Link from 'next/link';
import { useDispatch } from 'react-redux';
import { SearchResultSkeleton } from '../searchList/components';
import { useTrendingList } from './hooks';

export default function TrendingList() {
  const dispatch = useDispatch<AppDispatch>();
  const { data, loading } = useTrendingList();

  return (
    <div className='flex-1 overflow-y-scroll px-6 pb-8'>
      <p className='mb-3 text-sm font-bold tracking-wide text-zinc-700'>
        What’s Trending
      </p>
      {loading && (
        <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
          <SearchResultSkeleton />
          <SearchResultSkeleton />
          <SearchResultSkeleton />
          <SearchResultSkeleton />
        </div>
      )}
      <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
        {data?.map((item: any, id: number) => {
          return (
            <Link
              key={id}
              href={`/${item?.eventCode}`}
              className='flex cursor-pointer gap-4 rounded-md text-sm font-bold text-zinc-700'
              onClick={() => dispatch(setSearchPopup(false))}
            >
              <CommonImage
                src={item?.poster?.[0]?.url}
                alt='eventImg'
                width={130}
                height={80}
                className='h-[80px] w-[130px] rounded-lg'
              />
              <div>
                <p>{item?.name}</p>
                <p className='text-xs text-zinc-500'>
                  {item?.isRecurringEvent
                    ? item?.dateString
                    : formatEventDate(
                      item?.eventDate
                        ? Number(item?.eventDate)
                        : item?.startDate
                    )}
                </p>
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  );
}
